export type SiteCode = 'PETP' | 'VETP' | 'FRMP' | 'CORP'

export interface PageContext {
	template: string
	site: SiteCode
	locale: string
}

type SiteOrUnknown = SiteCode | 'unknown'

const SITE_CODES: SiteCode[] = ['PETP', 'VETP', 'FRMP', 'CORP']

let currentContext: PageContext | null = null

// This store is the non-React access path for page context.
// It exists because some callers, such as Core Web Vitals reporting, execute outside
// the React tree and therefore cannot consume context or hooks.
// Unlike React context, this is just a snapshot API: reads are synchronous, but callers
// do not subscribe to updates and must tolerate an unknown fallback before the provider
// has synced the latest committed value.
export const setPageContext = (context: PageContext): void => {
	currentContext = context
}

export const isSiteCode = (value: unknown): value is SiteCode => {
	return typeof value === 'string' && SITE_CODES.includes(value as SiteCode)
}

export const getTemplate = (): string => {
	return currentContext?.template ?? 'unknown'
}

export const getSite = (): SiteOrUnknown => {
	return currentContext?.site ?? 'unknown'
}

export const getLocale = (): string => {
	return currentContext?.locale ?? 'unknown'
}
